'use client';

import { showCookiePreferences, showDoNotSell } from 'osano/components';
import React from 'react';

// Which Osano UI a flagged link opens. SiteFooter is a Server Component, so it passes this
// serializable discriminator across the RSC boundary instead of a click handler.
type OsanoAction = 'doNotSell' | 'cookiePreferences';

const osanoActionHandlers: Record<OsanoAction, () => void> = {
    doNotSell: showDoNotSell,
    cookiePreferences: showCookiePreferences,
};

interface LinkObject {
    id?: string | null;
    title: string;
    url: string;
    // When set, the link opens the corresponding Osano UI instead of navigating.
    osanoAction?: OsanoAction;
}

interface LinkGroup {
    title: string;
    groupClass?: string;
    links: LinkObject[];
}

interface SiteFooterLinkProps {
    linkGroup: LinkGroup;
}

const FooterLink: React.FC<{ link: LinkObject }> = ({ link }) => {
    const { osanoAction } = link;
    if (osanoAction) {
        return (
            <a
                href={link.url}
                onClick={(event) => {
                    event.preventDefault();
                    osanoActionHandlers[osanoAction]();
                }}
            >
                {link.title}
            </a>
        );
    }

    return <a href={link.url}>{link.title}</a>;
};

const SiteFooterLink: React.FC<SiteFooterLinkProps> = ({ linkGroup }) => (
    <div className={linkGroup.groupClass}>
        <div className="pb-2">
            <b role="heading" aria-level={2}>
                {linkGroup.title}
            </b>
        </div>
        <ul className="text-sm space-y-3">
            {linkGroup.links.map((link, index) => (
                <li key={index}>
                    <FooterLink link={link} />
                </li>
            ))}
        </ul>
    </div>
);

export default SiteFooterLink;
